import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error", error, errorInfo);
        const isChunkError =
            error?.name === 'ChunkLoadError' ||
            /Loading chunk [\d\w]+ failed/i.test(error?.message || '') ||
            /Failed to fetch dynamically imported module/i.test(error?.message || '');

        if (isChunkError) {
            const lastReload = sessionStorage.getItem('last_chunk_reload');
            const now = Date.now();
            if (!lastReload || now - Number(lastReload) > 10000) {
                sessionStorage.setItem('last_chunk_reload', String(now));
                window.location.reload();
            }
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ 
                    padding: '40px', 
                    textAlign: 'center', 
                    background: 'var(--bg-secondary)', 
                    borderRadius: '12px',
                    margin: '20px',
                    border: '1px solid var(--error-color)'
                }}>
                    <h2 style={{ color: 'var(--error-color)' }}>Что-то пошло не так</h2>
                    <p style={{ color: 'var(--text-secondary)' }}>
                        Произошла непредвиденная ошибка в приложении. 
                        Попробуйте перезагрузить страницу или обратитесь в поддержку.
                    </p>
                    <button 
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 20px',
                            background: 'var(--primary-color)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            marginTop: '20px'
                        }}
                    >
                        Перезагрузить страницу
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
